import {
    CurrencyValues,
    DimensionsDto,
    FlyerPageDto, FlyerPagination,
    FlyerStatus,
    FlyerType, FontSelectObjDto,
    LanguageCulture,
    ScaleDto,
} from "../dtos";
import {Spots} from "../components/com/canvas/spots/Spots";

export const FLYER_CANVAS_MAX_WIDTH = 1024;
export const FLYER_CANVAS_MAX_HEIGHT = 820;

export const FLYER_SPOTS_MIN_WIDTH_PX = 40;
export const FLYER_SPOTS_MIN_HEIGHT_PX = 40;

// there 2 variables are NOT CONSTANTS! we will change them dynamically.
export let FLYER_CANVAS_WIDTH = FLYER_CANVAS_MAX_WIDTH;
export let FLYER_CANVAS_HEIGHT = FLYER_CANVAS_MAX_HEIGHT;

export const getCanvasWrapperSize = (): { containerWidth: number, containerHeight: number } => {
    const container = document.getElementById('flyerCanvasContainer');
    if (container) {
        const containerWidth = container.clientWidth !== 0 ? container.clientWidth - 32 : 1024;
        const containerHeight = container.clientHeight !== 0 ? container.clientHeight - 20 : 820;
        return {
            containerWidth,
            containerHeight
        }
    }
    return {
        containerWidth: 1024,
        containerHeight: 820
    }
}

export const getOriginalPageDimensions = (dto: FlyerPageDto) => {
    let originalWidth = dto.flpWidthPx!;
    let originalHeight = dto.flpHeightPx!;
    return {originalWidth, originalHeight};
};

// used to scale visual elements inside the canvas
export const getCanvasElementsScales = (
    realFlyerWidth: number,
    realFlyerHeight: number
): ScaleDto => {
    // both should be <= 1
    let scaleX = 1;
    let scaleY = 1;

    // ex:
    // realFlyerWidth = 500
    // FLYER_CANVAS_WIDTH = 600
    // scaleX = 600 / 500 > 1 (this is not what we expect because we need it to be <= 1)
    if (realFlyerWidth >= FLYER_CANVAS_WIDTH) {
        scaleX = FLYER_CANVAS_WIDTH / realFlyerWidth;
    }

    if (realFlyerHeight >= FLYER_CANVAS_HEIGHT) {
        scaleY = FLYER_CANVAS_HEIGHT / realFlyerHeight;
    }

    return {scaleX, scaleY};
};

// used to calculate canvas sizes
export const getCanvasSize = (
    realFlyerWidth: number,
    realFlyerHeight: number,
    fitToWidth: boolean = false,
    maxWidthForContainer: number,
    maxHeightForContainer: number
): DimensionsDto => {
    // let maxCanvasWidth = FLYER_CANVAS_MAX_WIDTH
    // let maxCanvasHeight = FLYER_CANVAS_MAX_HEIGHT

    /*let finalCanvasWidth: number = realFlyerWidth
      let finalCanvasHeight: number = realFlyerHeight

      let xScaler = 1
      let yScaler = 1

      if(realFlyerHeight <= maxCanvasHeight) {
          yScaler = realFlyerHeight / maxCanvasHeight // < 1
      }
      else {
          yScaler = maxCanvasHeight / realFlyerHeight // < 1
      }

      if(realFlyerWidth <= maxCanvasWidth) {
          xScaler = realFlyerWidth / maxCanvasWidth // < 1
      }
      else {
          xScaler = maxCanvasWidth / realFlyerWidth // < 1
      }

      finalCanvasWidth = finalCanvasWidth * xScaler
      finalCanvasHeight = finalCanvasHeight * yScaler

      */
    let finalCanvasWidth: number = realFlyerWidth;
    let finalCanvasHeight: number = realFlyerHeight;
    let finalCanvasTop: number = 50;
    let finalCanvasTranslateY: number = -50;

    // AFTER SCALING CALCULTATION:
    // ---------------------------
    let yScalerDown = 1;
    let xScalerDown = 1;

    if (fitToWidth) {
        if (
            finalCanvasWidth < maxWidthForContainer ||
            finalCanvasWidth > maxWidthForContainer
        ) {
            xScalerDown = maxWidthForContainer / finalCanvasWidth;
        }

        finalCanvasWidth *= xScalerDown;
        finalCanvasHeight *= xScalerDown;
    } else {
        if (finalCanvasHeight >= finalCanvasWidth) {
            // ensure that the resulting flyer has at least the maximum height
            if (
                finalCanvasHeight > maxHeightForContainer ||
                finalCanvasHeight < maxHeightForContainer
            ) {
                yScalerDown = maxHeightForContainer / finalCanvasHeight;
            }

            finalCanvasWidth *= yScalerDown;
            finalCanvasHeight *= yScalerDown;
        } else if (finalCanvasWidth > finalCanvasHeight) {
            if (
                finalCanvasWidth < maxWidthForContainer ||
                finalCanvasWidth > maxWidthForContainer
            ) {
                xScalerDown = maxWidthForContainer / finalCanvasWidth;
            }

            finalCanvasWidth *= xScalerDown;
            finalCanvasHeight *= xScalerDown;
            if (finalCanvasHeight > realFlyerHeight) {
                yScalerDown = maxHeightForContainer / realFlyerHeight;
                finalCanvasWidth = realFlyerWidth * yScalerDown;
                finalCanvasHeight = realFlyerHeight * yScalerDown;
            }
        }
    }

    if (fitToWidth && finalCanvasHeight >= maxHeightForContainer) {
        finalCanvasTop = 0.5;
        finalCanvasTranslateY = 0;
    }

    // we need to update the following global dimensions
    // otherwise calculation will be wrong in other places in code
    FLYER_CANVAS_WIDTH = finalCanvasWidth;
    FLYER_CANVAS_HEIGHT = finalCanvasHeight;

    let dimensions: DimensionsDto = {
        width: finalCanvasWidth,
        height: finalCanvasHeight,
        top: finalCanvasTop,
        translateY: finalCanvasTranslateY
    };

    return dimensions;
};

export const updateCanvasSize = (
    spots: Spots,
    realFlyerWidth: number,
    realFlyerHeight: number,
    fitToWidth: boolean,
    canvasId: string = "cavansTest"
) => {
    const {containerWidth, containerHeight} = getCanvasWrapperSize();
    let canvasDimensions = getCanvasSize(realFlyerWidth, realFlyerHeight, fitToWidth, containerWidth, containerHeight);

    spots.setDimensions(canvasDimensions.width, canvasDimensions.height);

    let canvas = document.getElementById(canvasId)!;
    canvas.setAttribute("width", `${canvasDimensions.width}`);
    canvas.setAttribute("height", `${canvasDimensions.height}`);

    let widthStr = `${canvasDimensions.width}px`;
    let heightStr = `${canvasDimensions.height}px`;
    let topStr = `${canvasDimensions.top === 0 ? "0" : `${canvasDimensions.top}%`}`;
    let transformStr = `translateY(${canvasDimensions.translateY === 0 ? "0" : `${canvasDimensions.translateY}%`})`;

    // $('.flyer_page_container').css('width', widthStr)
    // $('.flyer_page_container').css('height', heightStr)
    //
    // $('.flyer_page_container > img').css('width', widthStr)
    // $('.flyer_page_container > img').css('height', heightStr)
    //
    // $('.flyer_page_container > .canvas_container').css('width', widthStr)
    // $('.flyer_page_container > .canvas_container').css('height', heightStr)
    //
    // $('.flyer_page_container > .flyer_page_container_loader').css('width', widthStr)
    // $('.flyer_page_container > .flyer_page_container_loader').css('height', heightStr);

    document.documentElement.style.setProperty("--canvas-width", widthStr);
    document.documentElement.style.setProperty("--canvas-height", heightStr);
    document.documentElement.style.setProperty("--canvas-top", topStr);
    document.documentElement.style.setProperty("--canvas-transform", transformStr);
};

// Represent FLT_CODE in the FlyerType table
export const FLIPPING_FLYER_TYPE: FlyerType = {
    fltRecId: 3,
    // fltCode: "Flipping",
    fltCaption: "Flipping Flyer",
};
export const SMART_FLYER_TYPE: FlyerType = {
    fltRecId: 4,
    // fltCode: "Smart",
    fltCaption: "Smart Flyer",
};
export const SHOPPING_FLYER_TYPE: FlyerType = {
    fltRecId: 5,
    // fltCode: "Shopping",
    fltCaption: "Shopping Flyer",
};

export const FLYER_TYPES: FlyerType[] = [
    FLIPPING_FLYER_TYPE,
    SMART_FLYER_TYPE,
    SHOPPING_FLYER_TYPE,
];
export const getFlyerTypeByCaption = (caption: string): FlyerType | null => {
    var toReturn: FlyerType | null = null;

    FLYER_TYPES.forEach((flyerType: FlyerType) => {
        if (flyerType.fltCaption === caption) {
            toReturn = {...flyerType};
            return;
        }
    });

    return toReturn;
};

export const LANGUAGE_HEBREW: LanguageCulture = {
    lacRecId: 2,
    lacGuid: "737A9BB1-D196-EB11-9CCF-00155DAA8404",
    lacCode: "he-IL",
    lacCaption: "Hebrew",
    lacDir: "RTL",
    lacCurrencySymbol: "₪",
};

export const LANGUAGE_ENGLISH: LanguageCulture = {
    lacRecId: 1,
    lacGuid: "4ACFECAA-D196-EB11-9CCF-00155DAA8404",
    lacCode: "en-US",
    lacCaption: "English (US)",
    lacDir: "LTR",
    lacCurrencySymbol: "$",
};

export const CURRENCY_VALUES: CurrencyValues[] = [
    {
        value: "₪",
        label: "NIS",
    },
    {
        value: "$",
        label: "$",
    },
];

export const LANGUAGES: LanguageCulture[] = [LANGUAGE_HEBREW, LANGUAGE_ENGLISH];
export const getLanguageCultureByCaption = (
    caption: string
): LanguageCulture | null => {
    var langToReturn: LanguageCulture | null = null;

    LANGUAGES.forEach((lang: LanguageCulture) => {
        if (lang.lacCaption === caption) {
            langToReturn = {...lang};
            return;
        }
    });

    return langToReturn;
};

export const FONT_NAME_ARIAL = "Arial";
export const FONT_NAME_ROBOTO = "Roboto";
export const FONT_NAME_MONTSERRAT = "Montserrat";
export const FONT_NAME_LATO = "Lato";
export const FONT_NAME_POPPINS = "Poppins";
export const FONT_NAME_RALEWAY = "Raleway";
export const FONT_NAME_OPENSANS = "OpenSans";
export const FONT_NAME_OPENSANS_HEB = "OpenSansHeb";
export const FONT_NAME_ALMONI_TZAR = "AlmoniTzar";

export const FONTS: string[] = [
    FONT_NAME_ARIAL,
    FONT_NAME_ROBOTO,
    FONT_NAME_MONTSERRAT,
    FONT_NAME_LATO,
    FONT_NAME_POPPINS,
    FONT_NAME_RALEWAY,
];

export const FONTS_ARRAY_FOR_SELECT: FontSelectObjDto[] = [
    {value: FONT_NAME_ARIAL, label: FONT_NAME_ARIAL},
    {value: FONT_NAME_ROBOTO, label: FONT_NAME_ROBOTO},
    {value: FONT_NAME_MONTSERRAT, label: FONT_NAME_MONTSERRAT},
    {value: FONT_NAME_LATO, label: FONT_NAME_LATO},
    {value: FONT_NAME_POPPINS, label: FONT_NAME_POPPINS},
    {value: FONT_NAME_RALEWAY, label: FONT_NAME_RALEWAY},
    {value: FONT_NAME_OPENSANS, label: 'Open Sans'},
    {value: FONT_NAME_ALMONI_TZAR, label: 'Almoni Tzar (Hebrew)'},
    {value: FONT_NAME_OPENSANS_HEB, label: 'Open Sans (Hebrew)'}
];


export const getFontByName = (name: string): string | null => {
    var toReturn: string | null = null;

    FONTS.forEach((fontName: string) => {
        if (fontName === name) {
            toReturn = fontName;
            return;
        }
    });

    return toReturn;
};

export const FONT_SIZE_1 = 10;
export const FONT_SIZE_2 = 12;
export const FONT_SIZE_3 = 14;
export const FONT_SIZE_4 = 16;

export const FONT_SIZES: number[] = [
    FONT_SIZE_1,
    FONT_SIZE_2,
    FONT_SIZE_3,
    FONT_SIZE_4,
];
export const getFontSizeBySize = (size: number): string | null => {
    var toReturn: number | null = null;

    FONT_SIZES.forEach((fontSize: number) => {
        if (fontSize === size) {
            toReturn = fontSize;
            return;
        }
    });

    return toReturn;
};

// flyer status
export const FLYER_STATUS_IN_EDIT: FlyerStatus = {
    fstRecId: 1,
    fstGuid: "D5C58717-D196-EB11-9CCF-00155DAA8404",
    fstCode: 1,
    fstCaption: "In Edit",
};
export const FLYER_STATUS_QA: FlyerStatus = {
    fstRecId: 3,
    fstGuid: "C8F7BB22-D196-EB11-9CCF-00155DAA8404",
    fstCode: 2,
    fstCaption: "QA",
};
export const FLYER_STATUS_PUBLISHED: FlyerStatus = {
    fstRecId: 5,
    fstGuid: "85F27A44-D196-EB11-9CCF-00155DAA8404",
    fstCode: 3,
    fstCaption: "Published",
};
// export const FLYER_STATUS_INACTIVE: FlyerStatus = {
//     fstRecId: 6,
//     fstGuid: "85F27A44-D196-EB11-9CCF-00155DAA8404",
//     fstCode: 4,
//     fstCaption: "Inactive",
// };

export const FLYER_STATUSES: FlyerStatus[] = [
    FLYER_STATUS_IN_EDIT,
    FLYER_STATUS_QA,
    FLYER_STATUS_PUBLISHED,
    // FLYER_STATUS_INACTIVE,
];
export const getFlyerStatusByCaption = (
    caption: string
): FlyerStatus | null => {
    var toReturn: FlyerStatus | null = null;

    FLYER_STATUSES.forEach((flyerStatys: FlyerStatus) => {
        if (flyerStatys.fstCaption === caption) {
            toReturn = {...toReturn};
            return;
        }
    });

    return toReturn;
};

// flyer pagination
export const FLYER_PAGINATION_SINGLE_HORIZONTAL: FlyerPagination = {
    value: "4",
    label: 'Horizontal Paging, Single Pages'
};
export const FLYER_PAGINATION_DOUBLE_HORIZONTAL: FlyerPagination = {
    value: "1",
    label: 'Horizontal Paging, Double Pages'
};
export const FLYER_PAGINATION_DOUBLE_VERTICAL: FlyerPagination = {
    value: "2",
    label: 'Vertical Paging, Double Pages'
};
export const FLYER_PAGINATION_SINGLE_VERTICAL: FlyerPagination = {
    value: "3",
    label: 'Vertical Paging, Single Pages'
};
export const FLYER_PAGINATION_VARIANTS: FlyerPagination[] = [
    FLYER_PAGINATION_SINGLE_HORIZONTAL,
    FLYER_PAGINATION_DOUBLE_HORIZONTAL,
    FLYER_PAGINATION_SINGLE_VERTICAL,
    FLYER_PAGINATION_DOUBLE_VERTICAL,
];


export interface Dictionary<T> {
    [Key: string]: T;
}
